import type { Messages } from "../types";

export const nl = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exclusieve christelijke dating",
    "continue": "Doorgaan",
    "leave": "Verlaten",
    "leaveForNow": "Voor nu verlaten",
    "yes": "Ja",
    "no": "Nee",
    "goBack": "Terug",
    "saving": "Opslaan…",
    "submitting": "Verzenden…",
    "pleaseWait": "Even geduld…",
    "ellipsis": "…",
    "male": "Man",
    "female": "Vrouw",
    "phases": {
      "gate": "Poort",
      "verify": "Verifiëren",
      "setup": "Instellen",
      "profile": "Profiel"
    },
    "storageQuota": "Deze telefoon heeft geen ruimte meer voor opgeslagen antwoorden. Maak opslagruimte vrij en probeer het opnieuw.",
    "storageDisabled": "Deze browser slaat je antwoorden niet op. Zet de privémodus uit of sta sitegegevens toe, en laad daarna opnieuw.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} tekens"
  },
  "welcome": {
    "promise": "Ons doel is dat je deze app zo snel mogelijk verwijdert.",
    "sub": "UN8 helpt serieuze christelijke singles een levenspartner te vinden — en dan te vertrekken. Geverifieerd. Waarden eerst. Geen eindeloos swipen.",
    "signedInAs": "Ingelogd als {email}",
    "liveServer": " · live-server",
    "deviceOnly": " · alleen dit apparaat",
    "migrateOffer": "Dit apparaat heeft nog een lokaal profiel. Uploaden naar de gedeelde server zodat andere telefoons je na moderatie kunnen zien? Er wordt niets geüpload tot jij kiest.",
    "uploadLocalProfile": "Mijn lokale profiel uploaden",
    "keepOnDevice": "Alleen op dit apparaat houden",
    "migrateNeedGender": "Kies eerst Man of Vrouw in je profiel.",
    "migrateDone": "Profieltekst geüpload. Upload ID, video en foto’s opnieuw zodat moderatie ze kan beoordelen.",
    "deleteConfirm": "Je account, alle berichten en alle media (inclusief ID en video) permanent van de server verwijderen?",
    "accountDeleted": "Account verwijderd.",
    "begin": "Beginnen",
    "continueOnboarding": "Onboarding voortzetten",
    "logIn": "Inloggen",
    "logOut": "Uitloggen",
    "reviewConsole": "Beoordelingsconsole",
    "matching": "Matchen",
    "deleteMyAccount": "Mijn account verwijderen"
  },
  "faith": {
    "eyebrow": "Geloofspoort",
    "title": "Alleen christenen",
    "text": "UN8 is een gemeenschap van volgelingen van Jezus Christus, voor leden die een huwelijksgerichte partner zoeken die dat geloof deelt. Deze poort kun je niet overslaan.",
    "yesTitle": "Ik ben christen",
    "yesBody": "Ik volg Jezus Christus en zoek een huwelijksgerichte partner die dit geloof deelt.",
    "noTitle": "Ik ben geen christen",
    "noBody": "UN8 is niet de juiste plek voor mij — en dat is oké.",
    "respectTitle": "Met respect",
    "respectBody": "UN8 is gebouwd voor één gemeenschap, en we zijn liever eerlijk dan dat we je tijd verspillen. Gebruik hieronder Verlaten, of Terug, als dit niet jouw thuis is.",
    "sharedTitle": "Gedeelde basis",
    "sharedBody": "Geloof is hier geen etiket. Het is de grond waarop je elkaar ontmoet.",
    "hintNotChristian": "UN8 is voor volgelingen van Jezus Christus. Tik hieronder op Verlaten, of kies de christelijke optie als dat jij bent.",
    "hintUnset": "Tik op „Ik ben christen” om door te gaan, of Verlaten / Terug als dit niet jouw thuis is."
  },
  "rules": {
    "eyebrow": "Gemeenschapsverbond",
    "title": "Hoe we met elkaar omgaan",
    "text": "Bevestig elke regel. Alle drie zijn verplicht. Overtredingen leiden tot permanente verwijdering. Nepprofielen worden voor altijd verbannen.",
    "agreeContinue": "Ik ga akkoord — doorgaan",
    "respectful": {
      "title": "Wees respectvol",
      "description": "Spreek en handel met waardigheid. Iedereen hier is gemaakt naar Gods beeld."
    },
    "noSexualContent": {
      "title": "Geen seksuele inhoud",
      "description": "Geen expliciete foto’s, berichten of verzoeken. Reinheid is hier niet optioneel."
    },
    "noDominance": {
      "title": "Domineer of controleer niet",
      "description": "Geen dwang, manipulatie of druk. Liefde controleert niet."
    },
    "hint": "Vink alle drie de beloften aan voordat je doorgaat."
  },
  "intent": {
    "eyebrow": "",
    "title": "Waar ben je naar op zoek?",
    "text": "",
    "marriage": {
      "label": "Een levenspartner",
      "description": ""
    },
    "discernment": {
      "label": "Serieus onderscheiden",
      "description": ""
    },
    "notCasual": {
      "label": "Niets vrijblijvends",
      "description": ""
    },
    "hint": "Kies er één."
  },
  "account": {
    "eyebrow": "Account",
    "title": "Maak je toegang aan",
    "text": "Je handle maakt een stabiele gebruikers-id. Aanvraag, verificatie, likes en matches hangen allemaal aan die id. Er wordt geen e-mail gestuurd.",
    "recoveryTitle": "Bewaar je herstelcode",
    "recoveryText": "Eenmalig getoond. Zonder deze code kan een verloren wachtwoordzin in deze gesloten test niet worden gereset.",
    "savedContinue": "Ik heb hem bewaard — doorgaan",
    "handle": "Handle",
    "handlePlaceholder": "jij@voorbeeld.com of een korte handle",
    "passphrase": "Wachtwoordzin",
    "passphrasePlaceholder": "Minstens 8 tekens",
    "signedInTitle": "Ingelogd",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Vertrouwensstandaard",
    "trustBody": "Geen profiel is zichtbaar tot identiteitsverificatie voltooid is en moderatie je goedkeurt.",
    "continueToVerification": "Doorgaan naar verificatie",
    "hintEmail": "Typ een e-mailadres met @.",
    "hintPassword": "Kies een wachtwoord van minstens 8 tekens."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verificatie",
      "title": "Vertrouwen is de poort",
      "text": "Upload een officieel ID-bewijs, een bevestigingsvideo en {min}–{max} echte foto’s. Alles gaat eerst in een beoordelingswachtrij voordat je profiel kan verschijnen.",
      "whyTitle": "Waarom we verifiëren",
      "whyBody": "Catfishing en halve waarheden horen hier niet. Nepprofielen worden permanent verbannen. Media blijft in status pending_review tot goedkeuring.",
      "start": "Verificatie starten"
    },
    "steps": {
      "id": {
        "title": "Officieel ID-bewijs",
        "description": "Paspoort of nationaal ID — camera of bestandsupload."
      },
      "video": {
        "title": "Bevestigingsvideo",
        "description": "Een korte opname die bewijst dat jij aanwezig bent."
      },
      "photos": {
        "title": "Echte foto’s",
        "description": "Zeven tot tien duidelijke foto’s van jezelf."
      },
      "review": {
        "title": "Integriteitsbeoordeling",
        "description": "Uploads blijven pending_review tot medewerkers bevestigen."
      }
    },
    "id": {
      "eyebrow": "Stap 1 van 4",
      "title": "Officieel ID-bewijs",
      "text": "Maak of upload een foto van je paspoort of nationaal ID. Niets wordt openbaar geplaatst — status blijft pending_review tot medewerkers bevestigen.",
      "savedTitle": "ID opgeslagen",
      "savedBody": "Volgende is een korte bevestigingsvideo van je gezicht, daarna 7 tot 10 echte foto’s van jezelf. Doorgaan wordt vrijgegeven wanneer dit ID als opgeslagen staat.",
      "hint": "Maak of upload een foto van je officiële ID, en wacht tot er staat opgeslagen."
    },
    "video": {
      "eyebrow": "Stap 2 van 4",
      "title": "Bevestigingsvideo",
      "text": "Neem een kort filmpje op of upload er een. Kijk in de camera. Spreek duidelijk. Dit bewijst dat jij aanwezig bent — geen gescrapete galerij.",
      "hint": "Neem een korte bevestigingsvideo op, en wacht tot er staat opgeslagen."
    },
    "photos": {
      "eyebrow": "Stap 3 van 4",
      "title": "Echte foto’s",
      "text": "Voeg {min}–10 recente foto’s van jezelf toe. Gebruik de camera of je bibliotheek. Tik op × om een foto te verwijderen.",
      "continueToReview": "Doorgaan naar beoordeling",
      "hint": "Voeg {min} tot 10 duidelijke foto’s van jezelf toe. Doorgaan wordt vrijgegeven wanneer ze zijn opgeslagen."
    },
    "review": {
      "eyebrow": "Stap 4 van 4",
      "title": "Integriteitsbeoordeling",
      "text": "Media staat in de wachtrij als pending_review{underUser}. Matches en likes gebruiken dezelfde id.",
      "underUser": " onder gebruiker {userId}",
      "governmentId": "Officieel ID-bewijs",
      "confirmationVideo": "Bevestigingsvideo",
      "photos": "Foto’s",
      "missing": "Ontbreekt",
      "filesReady": "{count} bestanden klaar",
      "submittedTitle": "Ingediend voor beoordeling",
      "submittedText": "Aanvraag-id is gelijk aan auth-gebruikers-id zodat goedkeuren → pool en wederzijdse likes uitgelijnd blijven.",
      "submitContinue": "Indienen & doorgaan"
    }
  },
  "setup": {
    "eyebrow": "Account instellen",
    "title": "Vertel de waarheid over jezelf",
    "text": "Deze antwoorden vormen matching en verschijnen in beoordeling. Zachte leugens verspillen ieders tijd — inclusief die van jou.",
    "beginSetup": "Instellen beginnen",
    "pillars": {
      "faith": {
        "name": "Geloof",
        "text": "Waarom je Christus volgt."
      },
      "character": {
        "name": "Karakter",
        "text": "Loyaliteit, eerlijkheid, passie, toewijding — beoordeeld 1–10."
      },
      "story": {
        "name": "Verhaal",
        "text": "Wie je bent en wat je zoekt."
      },
      "life": {
        "name": "Leven",
        "text": "Hobby’s, lezen en beroep."
      }
    },
    "whyChristian": {
      "eyebrow": "Geloof",
      "title": "Waarom ben je christen?",
      "text": "Een kort, eerlijk antwoord. Geen preek — een reden die van jou is.",
      "label": "Jouw antwoord",
      "placeholder": "bijv. Ik ontmoette Christus in een seizoen van verlies en volg Hem sindsdien…",
      "hint": "Schrijf minstens {min} tekens over waarom je Jezus volgt."
    }
  },
  "scales": {
    "eyebrow": "Karakterschalen",
    "title": "Beoordeel jezelf eerlijk",
    "text": "Loyaliteit, eerlijkheid, passie, toewijding — elk van 1 tot 10. Opgeblazen cijfers zorgen later alleen voor mismatch. Je moet elke schaal zetten om door te gaan.",
    "loyalty": {
      "label": "Niveau van loyaliteit",
      "hint": "Wees eerlijk — hoe trouw sta je achter wie je liefhebt?"
    },
    "honesty": {
      "label": "Niveau van eerlijkheid",
      "hint": "Hoe consequent vertel je de volle waarheid?"
    },
    "passion": {
      "label": "Hoe gepassioneerd ben je?",
      "hint": "Overtuiging en diepgang — geen show."
    },
    "commitment": {
      "label": "Niveau van toewijding",
      "hint": "Hoe klaar ben je om iets te bouwen dat blijft?"
    },
    "hint": "Beweeg elke schuifregelaar zodat er een getal staat — geen mag een streepje blijven."
  },
  "about": {
    "eyebrow": "Over jou",
    "title": "Beschrijf jezelf in een paar zinnen",
    "text": "Wie je bent als niemand speelt. Temperament, ritme, wat er dagelijks toe doet.",
    "label": "Over jou",
    "placeholder": "Stille ochtenden, serieus over gezin, lach makkelijk, liever diepte dan lawaai…",
    "hint": "Schrijf minstens {min} tekens over jezelf."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Wat zoek je?",
    "text": "Belangrijkste karaktereigenschappen die je in een potentiële partner verlangt — geen winkellijst van uiterlijk.",
    "label": "Gewenste karaktereigenschappen",
    "placeholder": "bijv. Standvastig geloof, emotionele volwassenheid, vriendelijkheid onder stress…",
    "hint": "Schrijf minstens {min} tekens over de partner waarop je hoopt."
  },
  "loveReady": {
    "eyebrow": "Drempel",
    "title": "Ben je klaar om de liefde van je leven te ontmoeten?",
    "text": "UN8 bestaat zodat serieuze singles een partner vinden — en dan de app verwijderen. Alleen „Ja” ontgrendelt doorgaan.",
    "yesTitle": "Ja — ik ben klaar",
    "yesBody": "Ik ben hier om mijn persoon te ontmoeten met helderheid en moed.",
    "noTitle": "Nog niet",
    "noBody": "Als je alleen bladert, past deze gemeenschap niet.",
    "comeBackTitle": "Kom terug wanneer je klaar bent",
    "comeBackBody": "UN8 is voor mensen die bereid zijn te ontmoeten — niet om opties te verzamelen. Gebruik hieronder Verlaten als je nu wilt stoppen. Je antwoorden blijven op deze telefoon.",
    "hintNo": "Alleen „Ja” gaat verder. Als je nog niet klaar bent, tik op Voor nu verlaten — je antwoorden blijven op deze telefoon.",
    "hintUnset": "Tik op Ja als je klaar bent om iemand voor het huwelijk te ontmoeten."
  },
  "lifestyle": {
    "eyebrow": "Levensstijl",
    "title": "Hoe je dagelijks leeft",
    "text": "Sport, hobby’s, lezen en beroep — praktische signalen voor echte compatibiliteit.",
    "hobbies": "Huidige sport of hobby’s",
    "hobbiesPlaceholder": "Wat je actief doet — niet wat je ooit deed.",
    "reading": "Lees je?",
    "readingHint": "1 = bijna nooit · 10 = dagelijks, diep lezen",
    "profession": "Beroep / sector",
    "professionPlaceholder": "bijv. Verpleging · Software · Onderwijs · Ambacht",
    "hintHobbies": "Noem minstens één sport of hobby die je echt doet.",
    "hintReading": "Schuif „Lees je?” zodat een getal van 1 tot 10 verschijnt.",
    "hintProfession": "Typ het werk dat je doet, ook al is het één woord."
  },
  "faithDepth": {
    "eyebrow": "Matchen · Geloof",
    "title": "Hoe centraal staat je geloof?",
    "text": "God dienen — hoe belangrijk in je leven? Antwoord eerlijk. Matching gebruikt dit voor diepgang, niet voor show.",
    "serving": "God dienen — belang",
    "servingHint": "10% … 100%. Schuif in stappen van 10.",
    "keepsCommandments": "Houd je de geboden?",
    "grewUpInChurch": "Ben je opgegroeid in de kerk?",
    "churchAttendance": "Kerkbezoek",
    "frequent": {
      "label": "Regelmatig",
      "hint": "Regelmatig samenkomen met het lichaam van Christus."
    },
    "seldom": {
      "label": "Zelden",
      "hint": "Af en toe, geen wekelijks ritme."
    },
    "never": {
      "label": "Nooit",
      "hint": "Momenteel geen bezoek."
    },
    "spreadsGospel": "Verspreid je het evangelie?",
    "hasIdols": "Heb je afgoden?",
    "hintServing": "Schuif hoe belangrijk God dienen is in je leven.",
    "hintCommandments": "Antwoord of je de geboden houdt — Ja of Nee.",
    "hintGrewUp": "Antwoord of je bent opgegroeid in de kerk — Ja of Nee.",
    "hintAttendance": "Kies hoe vaak je naar de kerk gaat.",
    "hintGospel": "Antwoord of je het evangelie deelt — Ja of Nee.",
    "hintIdols": "Antwoord of je afgoden hebt — Ja of Nee."
  },
  "character": {
    "eyebrow": "Matchen · Karakter",
    "title": "Wie je thuis bent",
    "text": "Karakter voor hofmakerij — vrede stichten, manieren, eerlijkheid. Opgeblazen antwoorden zorgen later alleen voor mismatch.",
    "peacemaker": "Ben je een vredestichter?",
    "homebuilder": "Ben je een thuisbouwer?",
    "humorous": "Ben je humoristisch?",
    "caring": "Zorgzaam en aanhankelijk?",
    "peacefulHome": "Wil je een vredig thuis — zonder ruzie?",
    "manners": "Goede manieren?",
    "honestyRating": "Eerlijkheidsbeoordeling op deze vragenlijst",
    "honestyHint": "1–10 — hoe eerlijk beantwoord je?",
    "hintPeacemaker": "Beantwoord elk met Ja of Nee, te beginnen met vredestichter.",
    "hintHomebuilder": "Antwoord of je een thuisbouwer bent.",
    "hintHumorous": "Antwoord of je humoristisch bent.",
    "hintCaring": "Antwoord of je zorgzaam en aanhankelijk bent.",
    "hintPeaceful": "Antwoord of je een vredig thuis wilt.",
    "hintManners": "Antwoord of je goede manieren hebt.",
    "hintHonesty": "Schuif je eerlijkheidsbeoordeling van 1 tot 10."
  },
  "history": {
    "eyebrow": "Matchen · Geschiedenis",
    "title": "Verleden en gereedheid",
    "text": "Middelen, jeugd, littekens, en of je klaar bent voor een blijvende relatie. Waarheid hier beschermt jullie beiden.",
    "marijuana": "Heb je marijuana gebruikt?",
    "lsd": "Heb je LSD gebruikt?",
    "otherDrugs": "Heb je andere drugs gebruikt?",
    "addicted": "Ben je verslaafd geweest?",
    "childhood": "Stabiele, liefdevolle jeugd?",
    "scars": "Littekens / beschadigd?",
    "lasting": "Klaar voor een blijvende relatie?",
    "hintStart": "Beantwoord elk Ja of Nee op deze pagina, te beginnen bovenaan.",
    "hintLsd": "Beantwoord de LSD-vraag — Ja of Nee.",
    "hintOtherDrugs": "Antwoord of je andere drugs hebt gebruikt.",
    "hintAddicted": "Antwoord of je verslaafd bent geweest.",
    "hintChildhood": "Antwoord of je jeugd stabiel en liefdevol was.",
    "hintScars": "Antwoord of je littekens draagt.",
    "hintLasting": "Antwoord of je klaar bent voor een blijvende relatie."
  },
  "appearance": {
    "eyebrow": "Matchen · Uiterlijk",
    "title": "Tattoos",
    "text": "Jouw tattoos, en of tattoos bij een partner voor jou acceptabel zijn.",
    "hasTattoos": "Heb je tattoos?",
    "acceptsPartner": "Tattoos bij een partner accepteren?",
    "hintHas": "Zeg of je tattoos hebt — Ja of Nee.",
    "hintAccepts": "Zeg of tattoos bij een partner voor jou acceptabel zijn."
  },
  "home": {
    "eyebrow": "Matchen · Thuis & land",
    "title": "Land, vaardigheden, zelfvoorziening",
    "text": "Kruiden, voedsel verbouwen, fruitbos, preppen, gemeenschapsboerderij, conserveren, overleving — en eventuele speciale vaardigheden.",
    "herbKnowledge": "Kennis van kruiden?",
    "plantOwn": "Plant je eigen fruit en groenten?",
    "fruitForest": "Interesse in een fruitbos?",
    "prepping": "Voorbereiden op calamiteiten?",
    "communityFarming": "Gemeenschapsboerderij / onafhankelijk leven?",
    "canning": "Inmaken en conserveren?",
    "survival": "Overlevingsvaardigheden?",
    "specialSkills": "Speciale vaardigheden (optioneel)",
    "specialPlaceholder": "Alles wat je verder meebrengt naar een huishouden of land…",
    "hintStart": "Beantwoord elk Ja of Nee over land en vaardigheden, te beginnen bovenaan.",
    "hintPlant": "Antwoord of je eigen fruit en groenten plant.",
    "hintFruitForest": "Antwoord of een fruitbos je interesseert.",
    "hintPrepping": "Antwoord of je je voorbereidt op calamiteiten.",
    "hintCommunity": "Antwoord of gemeenschapsboerderij je interesseert.",
    "hintCanning": "Antwoord of je voedsel inmaakt en conserveert.",
    "hintSurvival": "Antwoord of je overlevingsvaardigheden hebt."
  },
  "family": {
    "eyebrow": "Matchen · Gezin",
    "title": "Kinderen, geloofsdiepte, middelen",
    "text": "Wat je in een partner nodig hebt rond geloofsintensiteit, kinderen en eerder middelengebruik.",
    "children": "Kinderen",
    "wants": {
      "label": "Wil kinderen",
      "hint": "Een gezin opbouwen hoort bij de visie."
    },
    "doesNotWant": {
      "label": "Wil geen kinderen",
      "hint": "Duidelijk nee op kinderen."
    },
    "open": {
      "label": "Open",
      "hint": "Onderscheidend — niet vastgelegd."
    },
    "hasLivingWith": {
      "label": "Heeft kinderen — woont met hen",
      "hint": "Kinderen horen al bij het dagelijks leven."
    },
    "requiredFaith": "Minimum geloofsniveau dat je in een partner nodig hebt",
    "requiredFaithHint": "10% … 100%. Harde poort wanneer beide kanten hebben geantwoord.",
    "acceptsSubstances": "Eerder middelengebruik bij een partner accepteren?",
    "hintChildren": "Kies één kaart over kinderen.",
    "hintFaith": "Schuif het minimum geloofsniveau dat je in een partner hoopt.",
    "hintSubstances": "Zeg of eerder middelengebruik bij een partner acceptabel is."
  },
  "ancestry": {
    "eyebrow": "Matchen · Achtergrond",
    "title": "Achtergrondvoorkeuren",
    "text": "Deel je achtergrond en waar je open voor staat bij een partner. Dit vormt alleen de ranking — het verbergt nooit iemand uit het deck.",
    "yourBackground": "Jouw achtergrond (selecteer alles wat van toepassing is)",
    "openToPartner": "Open voor bij een partner",
    "codeDesc": "Code: {code}",
    "anyDesc": "Sterkste voorkeur voor breedte — aanbevolen bij twijfel.",
    "preferenceOnly": "Alleen voorkeur — geen poort.",
    "hintOwn": "Vink minstens één achtergrond aan die jou beschrijft. Dit helpt alleen ranking — het verbergt nooit iemand.",
    "hintAccepted": "Vink aan waar je open voor staat bij een partner, of „Open — geen voorkeur”."
  },
  "interests": {
    "eyebrow": "Matchen · Interesses",
    "title": "Wat je leuk vindt",
    "text": "Kies er minstens één. Overlap helpt ranking; stilte wordt nooit bestraft.",
    "hint": "Vink minstens één interesse aan."
  },
  "reflection": {
    "eyebrow": "Matchen · Reflectie",
    "title": "In je eigen woorden",
    "text": "Deze vier antwoorden worden volledig getoond en nooit gescoord. Schrijf wat waar is.",
    "describeYourself": "Beschrijf jezelf",
    "lifePurpose": "Levensdoel",
    "fifteenYear": "Jij en de liefde van je leven over 15 jaar",
    "weaknesses": "Zwaktes",
    "hintDescribe": "Beschrijf jezelf in minstens {min} tekens.",
    "hintPurpose": "Schrijf je levensdoel in minstens {min} tekens.",
    "hintVision": "Schrijf de 15-jaarsvisie in minstens {min} tekens.",
    "hintWeaknesses": "Noem een zwakte in minstens {min} tekens."
  },
  "profile": {
    "eyebrow": "Profiel",
    "title": "Een paar essentials",
    "text": "Houd het eenvoudig. Geslacht is hier binair — man of vrouw — voor duidelijke matching.",
    "firstName": "Voornaam",
    "firstNamePlaceholder": "Zoals je bekend wilt staan",
    "age": "Leeftijd",
    "agePlaceholder": "18+",
    "city": "Stad",
    "cityPlaceholder": "Waar je woont",
    "sex": "Geslacht",
    "maleBody": "Ik ben een man.",
    "femaleBody": "Ik ben een vrouw.",
    "hintName": "Typ je voornaam (minstens twee letters).",
    "hintAge": "Leeftijd moet 18 of ouder zijn.",
    "hintCity": "Typ de stad waar je woont.",
    "hintGender": "Kies Man of Vrouw zodat matching kan werken."
  },
  "ready": {
    "title": "Je mag binnenkomen.",
    "textNamed": "{name}, je verificatie en setup zijn vastgelegd. Media is pending_review. Welkom bij UN8 — vind je persoon, en verwijder dan de app.",
    "text": "Je verificatie en setup zijn vastgelegd. Media is pending_review. Welkom bij UN8 — vind je persoon, en verwijder dan de app.",
    "summaryAria": "Setup-samenvatting",
    "christianRules": "Christen · regels bevestigd",
    "mediaLine": "ID · video · {photoCount} foto’s · wachtrij {pending}",
    "scalesLine": "Schalen L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Geslacht —",
    "professionFallback": "beroep",
    "userLine": "Gebruiker {userId}",
    "enterMatching": "Naar matching",
    "needGender": "Ga terug naar de profielstap, kies Man of Vrouw, en probeer opnieuw."
  },
  "match": {
    "brandTag": "Matchen",
    "navOnboarding": "Onboarding",
    "navReview": "Beoordeling",
    "navMatching": "Matchen",
    "logOut": "Uitloggen",
    "enterTitle": "Matching starten",
    "enterText": "Log in met hetzelfde e-mailadres als bij onboarding. Aanvraag, pool, likes en matches gebruiken allemaal je stabiele gebruikers-id.",
    "email": "E-mail",
    "emailPlaceholder": "jij@voorbeeld.com",
    "password": "Wachtwoord",
    "passwordPlaceholder": "Je wachtwoord",
    "logIn": "Inloggen",
    "guestOr": "Of probeer een gastsessie (stabiele id per browser · alleen demo)",
    "guestMan": "Gast als man",
    "guestWoman": "Gast als vrouw",
    "goOnboarding": "Naar onboarding →",
    "guestSession": "Gastsessie · demopool",
    "packTitle": "Jouw vier",
    "packSkip": "Tik om door te gaan",
    "newSelection": "Nieuwe selectie",
    "backToFour": "← Terug naar jouw vier",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "man",
    "woman": "vrouw",
    "navSelection": "Selectie",
    "navMessages": "Berichten",
    "navProfile": "Profiel",
    "tabToday": "Selectie",
    "tabMatches": "Matches ({count})",
    "yourMatches": "Jouw matches",
    "matchesSub": "Blijvende wederzijdse interesse · {count} uitgaande {likesWord}",
    "like": "like",
    "likes": "likes",
    "emptyMatches": "Nog geen wederzijdse interesse. Blijf deze week de selectie onderscheiden.",
    "valuesScore": "Waarden {score}",
    "chatOpen": " · Chat geopend",
    "tapToChat": " · Tik om te chatten",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Waarden {score}",
    "noProfileYet": "Nog geen profiel",
    "noProfileText": "Rond onboarding af, of tik bovenaan op Onboarding en daarna Beginnen. Gastmatching staat op het startscherm als je alleen wilt kijken.",
    "matchingPaused": "Matching gepauzeerd",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Nog niemand om te tonen",
    "todaysSetDone": "Dat is de selectie van deze week",
    "weeklyTitle": "Jouw 4 voor deze week",
    "weeklyTitleCount": "Jouw {count} voor deze week",
    "weeklyCountdown": "Volgende selectie over {days} dagen",
    "weeklyCountdownOne": "Volgende selectie over 1 dag",
    "weeklyCountdownSoon": "Volgende selectie binnenkort",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Dat is de selectie van deze week",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Er staat nog niemand op de lijst van deze week. De pool vult zich — open Selectie zo opnieuw, of kom terug als er meer leden zijn goedgekeurd.",
    "emptyDone": "Je hebt de selectie van deze week doorlopen. Kom terug bij de volgende opening, of reset het dek.",
    "likesMayNotStick": " Likes blijven misschien niet hangen.",
    "poolMeta": "Pool: {pool} · Matches: {matches} · Geliked: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Deck resetten",
    "backOnboarding": "Terug naar onboarding",
    "feedEyebrowDemo": "Wekelijkse selectie · Demo",
    "feedEyebrowLive": "Wekelijkse selectie · Pool ({source}, {count})",
    "feedTitle": "Onderscheid met zorg",
    "left": "nog {count}",
    "pass": "Passeren",
    "interested": "Geïnteresseerd",
    "swipeHint": "Swipe of gebruik de knoppen. Een match opent alleen bij wederzijdse, vastgelegde interesse.",
    "celebrationEyebrow": "Wederzijdse interesse",
    "celebrationTitle": "Jullie matchten",
    "celebrationText": "{self} en {other} toonden beiden interesse. Waardenafstemming: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat is ontgrendeld voor deze match. Blijf respectvol — verbond boven gemak.",
    "openChat": "Chat openen",
    "keepDiscerning": "Blijf onderscheiden",
    "cardSeeking": "Zoekt",
    "cardHobbies": "Hobby’s",
    "affinity": "Affiniteit",
    "valuesScoreLabel": "Waardenscore",
    "scoreStrong": "Sterke afstemming",
    "scoreSolid": "Solide afstemming",
    "scoreModerate": "Matige afstemming",
    "scoreDifferent": "Andere ritmes",
    "characterAxisFoot": "Karakteras omvat de vier pijlers",
    "youThem": "Jij {self} · Zij {other}",
    "stampInterest": "Interesse",
    "stampPass": "Passeren",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Jullie waardenscores liggen dicht bij elkaar ({score} van 100).",
    "explainLegacyFuller": "Een vollere „waarom” verschijnt nadat jullie beiden de matchingvragen hebben afgerond.",
    "explainFaith": "Jullie geloofsintensiteit ligt dicht bij elkaar — jullie nemen Jezus volgen even serieus.",
    "explainCharacter": "Hoe jullie mensen thuis behandelen komt overeen — vrede, manieren en zorg.",
    "explainPurpose": "Jullie beoordeelden je eigen eerlijkheid vergelijkbaar, een teken van gedeelde ernst.",
    "explainHome": "Jullie delen interesse in land, voedsel verbouwen of een zelfvoorzienend thuis.",
    "explainAncestry": "Jullie geven beiden de voorkeur aan vergelijkbare familieachtergronden. Dat is een voorkeur, geen filter — niemand wordt erdoor verborgen.",
    "explainTemperament": "Jullie interesses en temperament overlappen.",
    "explainFallback": "Er is een mogelijke match op de antwoorden die jullie beiden hebben ingevuld.",
    "explainOverall": "Totale affiniteit {score} van 100.",
    "affinityAxes": {
      "faith": "Geloofsintensiteit",
      "character": "Karakter & gedrag",
      "purpose": "Afstemming levensdoel",
      "home": "Thuis & zelfvoorziening",
      "ancestry": "Culturele & achtergrondaffiniteit",
      "temperament": "Temperamentfit"
    },
    "scaleAxes": {
      "loyalty": "Loyaliteit",
      "honesty": "Eerlijkheid",
      "passion": "Passie",
      "commitment": "Toewijding"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat niet beschikbaar",
    "unavailableText": "Deze match ontbreekt of hoort niet bij jouw sessie.",
    "backToMatches": "Terug naar matches",
    "backMatches": "← Matches",
    "valuesSubscriber": "Waarden {score} · Abonnee",
    "valuesTrial": "Waarden {score} · Proefperiode",
    "valuesKept": "Waarden {score} · Match behouden",
    "empty": "Zeg hallo met zorg. Op de gedeelde backend synchroniseren berichten naar beide telefoons na een wederzijdse match.",
    "placeholder": "Bericht aan {name}…",
    "ariaMessage": "Bericht",
    "send": "Versturen"
  },
  "billing": {
    "paywallCopy": "Na je gratis proefperiode houd je iedereen met wie je al hebt gematcht en blijf je chatten. Om nieuwe mensen te zien, abonneer je.",
    "signInToMatch": "Log in om matching te gebruiken.",
    "signInFirst": "Log eerst in.",
    "subscriberUntil": "Abonnee · tot {date}",
    "renewal": "verlenging",
    "freeTrial": "Gratis proefperiode · {days} dagen (eindigt {date})",
    "soon": "binnenkort",
    "trialEnded": "Proefperiode beëindigd · matches & chat blijven open",
    "subscribe": "Abonneren · ${price}/mnd",
    "subscribeEarly": "Vroeg abonneren · ${price}/mnd",
    "activeNote": "Abonnement actief — je kunt weer nieuwe mensen zien.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Bewaar je herstelcode",
    "recoveryText": "Schrijf dit nu op. Het wordt eenmaal getoond. Als je je wachtwoordzin kwijtraakt, is deze code de enige manier om die te resetten in de gesloten test.",
    "savedContinue": "Ik heb hem bewaard — doorgaan",
    "welcomeBack": "Welkom terug",
    "createAccount": "Maak je account aan",
    "intro": "Handle en wachtwoordzin. Er wordt geen e-mail of sms gestuurd. Je id blijft stabiel over onboarding, beoordeling en matching.",
    "tabLogin": "Inloggen",
    "tabRegister": "Registreren",
    "handle": "Handle",
    "handlePlaceholder": "jij@voorbeeld.com of een korte handle",
    "passphrase": "Wachtwoordzin",
    "passphrasePlaceholder": "Minstens 8 tekens",
    "submitLogin": "Inloggen",
    "submitRegister": "Account aanmaken",
    "backWelcome": "Terug naar welkom"
  },
  "options": {
    "origin": {
      "african": "Afrikaans",
      "european": "Europees",
      "asian": "Aziatisch",
      "latino": "Latino / Hispanic",
      "middleEastern": "Midden-Oosters",
      "indigenous": "Inheems",
      "mixed": "Gemengd",
      "other": "Anders",
      "dutch": "Nederlands",
      "german": "Duits",
      "any": "Open — geen voorkeur"
    },
    "interest": {
      "prayer": "Gebed",
      "worship": "Aanbidding",
      "reading": "Lezen",
      "hiking": "Wandelen",
      "music": "Muziek",
      "cooking": "Koken",
      "farming": "Boeren / tuinieren",
      "sports": "Sport",
      "missions": "Zending",
      "family": "Gezinsleven",
      "crafts": "Handwerk",
      "outdoors": "Buiten"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ja",
      "no": "Nee"
    },
    "id": {
      "titleEmpty": "Officieel ID-bewijs",
      "titleReady": "ID klaar",
      "hintEmpty": "Paspoort of nationaal ID. Maak een live foto, of kies een afbeelding/PDF. Alle vier hoeken zichtbaar.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · opgeslagen",
      "previewAlt": "Voorbeeld officieel ID",
      "pdfAria": "PDF-document geselecteerd",
      "takePhoto": "Foto maken",
      "retake": "Opnieuw",
      "chooseFile": "Bestand kiezen",
      "replaceFile": "Bestand vervangen",
      "remove": "Verwijderen",
      "uploading": "Uploaden…",
      "cameraTitle": "Fotografeer je ID",
      "signIn": "Log in voordat je ID uploadt.",
      "uploadFailed": "Upload mislukt. Probeer opnieuw.",
      "badFile": "Dit bestand kon niet worden gebruikt."
    },
    "video": {
      "titleEmpty": "Bevestigingsvideo",
      "titleLive": "Camera live",
      "titleReady": "Video klaar",
      "hintEmpty": "Zeg je voornaam en dat je eerlijk bij UN8 komt. 5–15 seconden.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Opnemen",
      "cameraUpload": "Camera-upload",
      "chooseFile": "Bestand kiezen",
      "startRecording": "Opname starten",
      "cancel": "Annuleren",
      "stopSave": "Stop & opslaan",
      "recordAgain": "Opnieuw opnemen",
      "replaceFile": "Bestand vervangen",
      "remove": "Verwijderen",
      "unsupported": "Live opname is hier niet beschikbaar. Gebruik camera-upload of kies een bestand.",
      "permissionDenied": "Cameratoestemming geweigerd. Je kunt nog steeds een kort videobestand uploaden.",
      "signIn": "Log in voordat je video uploadt.",
      "uploadFailed": "Upload mislukt. Probeer opnieuw.",
      "saveFailed": "Opname kon niet worden opgeslagen.",
      "badVideo": "Deze video kon niet worden gebruikt."
    },
    "photos": {
      "count": "{count} / {max} foto’s",
      "minimumMet": "Minimum gehaald",
      "moreRequired": "Nog {n} nodig",
      "listAria": "Verificatiefoto’s",
      "photoAlt": "Foto {n}",
      "removeAria": "Foto {n} verwijderen",
      "camera": "Camera",
      "takePhoto": "Foto maken",
      "chooseFiles": "Bestanden kiezen",
      "uploading": "Uploaden…",
      "hint": "Foto maken opent de live camera. Bestanden kiezen is alleen voor galerijkeuzes. Duidelijke gezichtsfoto’s — geen filters die identiteit verbergen. Max {max}.",
      "cameraTitle": "Maak een foto van jezelf",
      "signIn": "Log in voordat je foto’s uploadt.",
      "someFailed": "Sommige foto’s zijn niet geüpload. Probeer de mislukte opnieuw.",
      "addFailed": "Foto’s konden niet worden toegevoegd."
    },
    "liveStill": {
      "titleDefault": "Camera",
      "close": "Sluiten",
      "capture": "Vastleggen",
      "cancel": "Annuleren",
      "hint": "Houd stil. De live camera blijft open tot je vastlegt.",
      "unavailable": "Camera is niet beschikbaar in deze browser. Gebruik in plaats daarvan Bestand kiezen.",
      "permissionDenied": "Cameratoestemming geweigerd of niet beschikbaar. Gebruik in plaats daarvan Bestand kiezen.",
      "frameFailed": "Dit frame kon niet worden vastgelegd.",
      "saveFailed": "De foto kon niet worden opgeslagen."
    },
    "uploadStatus": {
      "uploading": "uploaden…",
      "failed": "upload mislukt",
      "savedLocally": "lokaal opgeslagen",
      "uploaded": "geüpload",
      "stored": "opgeslagen",
      "awaitingUpload": "Wacht op upload",
      "localFallbackNote": "{error} Bestand is op dit apparaat opgeslagen; probeer opnieuw wanneer het sign-endpoint beschikbaar is."
    }
  },
  "language": {
    "label": "Taal",
    "choose": "Kies taal"
  },
  "shell": {
    "back": "Terug",
    "goBackAria": "Ga terug"
  }
} as Messages;
